import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from './dictionaries/de.json';
import en from './dictionaries/en.json';
import pl from './dictionaries/pl.json';

/*
 * Panel mówi TYLKO trzema językami: polskim, angielskim i niemieckim. Pozostałe dziesięć
 * słowników pozostawało w tyle za panelem, więc ich języki dawały ekrany sklejone z
 * przetłumaczonych i nieprzetłumaczonych fragmentów. Języki, w których hotel prowadzi
 * treści dla gościa, są od tego niezależne i wybiera się je w kontekście językowym.
 *
 * Brakujący klucz schodzi do angielskiego (`fallbackLng`), nie do klucza technicznego.
 */
const resources = {
  de: { translation: de },
  en: { translation: en },
  pl: { translation: pl },
};

// Pobierz język z różnych źródeł według priorytetu
const getInitialLanguage = (): string => {
  // 0. Sprawdź locale z URL (np. /pl/settings -> 'pl')
  try {
    const pathLocaleMatch = window.location.pathname.match(/^\/([a-z]{2})(\/|$)/);
    if (pathLocaleMatch && Object.keys(resources).includes(pathLocaleMatch[1])) {
      return pathLocaleMatch[1];
    }
  } catch {
    // ignore
  }

  // 1. Sprawdź język użytkownika z bazy danych (cache w localStorage)
  try {
    const userMeta = localStorage.getItem('auth.user.meta');
    if (userMeta) {
      const parsed = JSON.parse(userMeta);
      if (parsed?.userLanguage) {
        return parsed.userLanguage;
      }
    }
  } catch {
    // ignore
  }

  // 2. Sprawdź język z languageState (Zustand storage)
  try {
    const languageStorage = localStorage.getItem('language-storage');
    if (languageStorage) {
      const parsed = JSON.parse(languageStorage);
      if (parsed?.state?.language) {
        return parsed.state.language;
      }
    }
  } catch {
    // ignore
  }

  // 3. Użyj języka przeglądarki
  try {
    const browserLanguage = navigator.language.split('-')[0].toLowerCase();
    if (Object.keys(resources).includes(browserLanguage)) {
      return browserLanguage;
    }
  } catch {
    // ignore
  }

  // 4. Fallback na angielski
  return 'en';
};

const initialLanguage = getInitialLanguage();

if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: initialLanguage,
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false,
      },
      react: {
        useSuspense: false,
      },
    });
}

export { i18n };
export const t = (key: string): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result = (i18n as any).t(key);
  return typeof result === 'string' ? result : String(result);
};
